import { useTranslation } from "react-i18next";

// The homepage's language: the app's, which it takes from the page's path
// (/en is English, the rest Italian). Each section keeps its words in both,
// as `{ it, en }`, and shows the ones this returns.
export function useHomeLang() {
  const { i18n } = useTranslation();
  return (i18n?.language || "it").slice(0, 2) === "en" ? "en" : "it";
}
